import React from 'react';
import { DeliveryDashboardScreens } from '../../models/model-enum';
import DashboardManageDelivery from '../DashboardManageDelivery';
import DashboardOrderDetail from '../DashboardOrderDetail';
import { IDeliveryStatus } from '../../models/model-interface';
import DashboardCourierDetail from '../DashboardCourierDetail';
import useDashboardStore from '../../hooks/use-dashboard-store';
import { useDashboardUIStore } from '../../store/dashboardUIStore';
import DashboardDeliveryData from '../DashboardDeliveryData';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import DashboardMapSettings from '../DashboardMapSettings';

export const DashboardScreenRouter = () => {
  const { activeScreen, activeCourierId } = useDashboardUIStore();
  const { courierStatus } = useDashboardStore();
  const { isResolutionMobile } = useDeviceDetect();
  const screenRoutes: any = {
    [DeliveryDashboardScreens.MANAGE_DELIVERY_SCREEN]: <DashboardManageDelivery />,
    [DeliveryDashboardScreens.ORDER_DETAIL_SCREEN]: <DashboardOrderDetail />,
    [DeliveryDashboardScreens.COURIER_DETAIL_SCREEN]: (
      <DashboardCourierDetail
        courierStatus={
          courierStatus?.find((s: IDeliveryStatus) => s.courierId === activeCourierId)
            ?.currentDeliveryStatus
        }
      />
    ),
    [DeliveryDashboardScreens.DELIVERY_DATA_SCREEN]: (
      <>
        {!isResolutionMobile ? <DashboardManageDelivery /> : <></>}
        <DashboardDeliveryData />
      </>
    ),
    [DeliveryDashboardScreens.MAP_SETTINGS_SCREEN]: (
      <>
        <DashboardManageDelivery />
        <DashboardMapSettings />
      </>
    ),
  };

  return screenRoutes[activeScreen];
};

export default DashboardScreenRouter;
